<template>
    <div
        class="flex flex-col gap-3 justify-center provider-card"
        :title="provider.name"
    >
        <div
            class="w-full"
            @click="handleClick"
        >
            <div class="w-full h-full relative">
                <img
                    :src="displayImage"
                    :alt="provider.name"
                    class="w-full h-full"
                />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ProviderCard",
    props: {
        provider: {
            type: Object,
            required: true,
        },
        clickable: {
            type: Boolean,
            default: true,
        },
        category: {
            type: String,
            default: ''
        }
    },
    computed: {
        displayImage() {
            const categoryType = this.category;

            if (!this.provider?.category_images) return this.provider.image;

            // Find matching category image
            const match = this.provider.category_images.find(
                ci => ci.category_code?.toUpperCase() === categoryType.toUpperCase()
            );

            return match?.image || this.provider.image;
        }
    },
    methods: {
        handleClick() {
            if (!this.clickable) return;
            this.$emit("click", this.provider);
        },
    },
};
</script>

<style scoped>
.provider-card:hover {
    transform: scale(1.03);
    transition: transform 0.2s ease;
}
</style>
